import React, { useEffect, useState } from 'react'
import SearchBar from '../SearchBar/SearchBar'
import Status from '../HeadingSection/ListFilters/Status'
import Duration from '../HeadingSection/ListFilters/Duration'
import CampaignList from '../CampaignList/CampaignList'
import { Link } from 'react-router-dom'
import Add from "../../../assets/images/add.svg";
import "./UserCampaign.css";
import FilterIcon from "../../../assets/icons/Tuning.svg"
import NocampaignIllustration  from "./../../../assets/images/no-campaign-illustration.png"

import { useSelector, useDispatch } from 'react-redux'
import { fetchAllCampaignDetails } from '../../../store/campaigns-slice'

const UserCampaign = ({home, campaigns, campaignsSection}) => {
    const [status, setStatus] = useState("ALL_STATUS") ;
    const [duration, setDuration] = useState("Last 30 days") ;
    const [searchTerm, setSearchTerm] = useState("");
    const [showFilter, setShowFilter]=useState(false);
    
    return (
        <div className="c-list">
            {home && 
            <>
            <div style={{marginBottom: "1rem", paddingBottom: "1rem", borderBottom: "1px solid #E0E0E0"}}   className="c-listHeading">
                <h1 className='c-listHeading-heading'>Your campaigns</h1>
                {/* <span className='c-listHeading-createNewCampaign'>
                    <img className='c-listHeading-createNewCampaignImg' src={Add} alt="add-icon" />
                    <Link to="/create-campaign" className="c-listHeading-createNewCampaignLink">Create new Campaign</Link>
                </span> */}
            </div>
            </>}
            {campaigns && 
            <>
            <div className="listHeading-section">
                <SearchBar 
                // searchTerm={searchTerm} 
                // setSearchTerm={setSearchTerm} 
                placeholder='Search for the campaign' icon={FilterIcon} setShowFilter={setShowFilter} showFilter={showFilter} />
                {showFilter && <div className="list-filters">
                    <Status status={status} setStatus={setStatus} />
                    {/* <Duration duration={duration} setDuration={setDuration} /> */}
                </div>}
            </div>
            <CampaignList searchTerm={searchTerm} status={status}  duration={duration} campaigns={campaigns} />
            </>
            }
            {!campaigns && 
                <div className='noCampaigns' >
                    <img src={NocampaignIllustration} />
                    <p>You dont have any campaign yet. Please run a campaign.</p>
                </div>
            }
        
        </div>
    )
}

export default UserCampaign